// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class NonFixedNewInstumentRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_INSTRUMENT_REQUEST, fieldSet);
    }
    setInstrumentID(instrID) {
        this.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, instrID);
    }
    setInstrumentName(instrName) {
        this.setFieldValue(FieldsFactory.FIELD_NAME, instrName);
    }
    setInstrumentTradableID(instrName) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrName);
    }
    setRequestId(p) {
        this.setFieldValue(FieldsFactory.FIELD_REQUEST_ID, p);
    }
}
